import { render } from "./ReceptoresFactura.vue?vue&type=template&id=f2a41114&scoped=true"
import script from "./ReceptoresFactura.vue?vue&type=script&lang=ts"
export * from "./ReceptoresFactura.vue?vue&type=script&lang=ts"

import "./ReceptoresFactura.vue?vue&type=style&index=0&id=f2a41114&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f2a41114"

export default script